module.exports = __webpack_public_path__ + "img/signalizator_cover.63a4df4f.webp";